import { Outlet } from "react-router-dom";

const Network = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Network;
